<template>
  <DashBoardCard title="Concurrent Tickets" :loading="loading">
    <template slot="content">
      <DonutChart id="current-ticket" :data="concurrentTickets" :colors="['#D3732D', '#8D9097']" :center-text="totalTickets" center-desc="Total tickets"/>
      <div id="legend">
        <div id="legend-open-ticket">
          <span>{{ overview.opening }}</span>
          <span>Opening Tickets</span>
        </div>
        <div id="legend-resolved-tickets">
          <span>{{ overview.resolved }}</span>
          <span>Resolved Tickets</span>
        </div>
      </div>
    </template>
    <template slot="action">
      <div>
        <v-menu offset-y :close-on-content-click="false" max-height="400" left>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" flat class="text-none">
              <v-icon size="16px">mdi-filter</v-icon>
              <span style="font-size: 14px">Channel</span>
            </v-btn>
          </template>
          <div class="menu-items">
            <div v-for="(channel, idx) in channels" v-bind:key="channel.key" :class="`menu-item ${idx === 0 ? 'radius-top' : ''} ${idx === channels.length - 1 ? 'radius-bottom' : ''}`">
              <v-checkbox @change=getOverview(selectedChannels.join()) height="20px" v-model="selectedChannels" color="#2151C5" hide-details :label="channel.name" :value="channel.key"/>
            </div>
          </div>
        </v-menu>
      </div>
    </template>
  </DashBoardCard>
</template>

<script>
import DashBoardCard from "@/views/dashboard-realtime/DashBoardCard";
import DonutChart from "components/charts/DonutChart";
import $const from "@/utils/const";
import * as _ from "lodash";
import {mapActions, mapGetters, mapState} from "vuex";
import {mapFields} from "vuex-map-fields";
export default {
  name: "ConcurrentTicket",
  components: {DonutChart, DashBoardCard},
  mounted() {
    this.getOverview(this.selectedChannels.join());
  },
  computed: {
    ...mapGetters('ticket', ['concurrentTickets']),
    ...mapState('ticket', ['overview', 'loading']),
    ...mapFields('ticket', ['selectedChannels']),
    totalTickets() {
      return (this.overview.opening + this.overview.resolved).toString();
    },
    channels() {
      const channelEntries = Object.entries($const.INTEGRATION_CHANNEL);
      // Remove channel All
      channelEntries.shift()
      return _.map(channelEntries, ([name, key]) => {
        name = name.toLowerCase().replaceAll("_", " ")
        return {
          key,
          name: name.charAt(0).toUpperCase() + name.slice(1)
        }
      })
    },
  },
  methods: {
    ...mapActions('ticket', ['getOverview'])
  }
}
</script>

<style scoped lang="scss">
::v-deep.v-input--selection-controls {
  margin: 0 !important;
}
::v-deep.v-input--selection-controls.v-input .v-label {
  color:#141519 !important;
}
.radius-top {
  border-radius: 5px 5px 0 0;
}
.radius-bottom {
  border-radius: 0 0 5px 5px;
}
.menu-items {
  display: flex;
  flex-direction: column;
  background-color: #EDEDF2;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  gap: 1px;
  padding: 1px 0;
  .menu-item {
    padding: 6px 10px;
    display: flex;
    background-color: white;
    width: 100%;
  }
}
#legend {
  display: flex;
  #legend-open-ticket{
    display: flex;
    flex-direction: column;
    box-shadow: 1px 0 0 #E2E2ED;
    align-items: center;
    padding: 0 20px;
    span:first-child {
      color: #D3732D;
      font-size: 20px;
      font-weight: bold;
    }
    span:last-child {
      font-size: 14px;
      color: #525463;
    }
  }
  #legend-resolved-tickets{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    span:first-child {
      color: #8D9097;
      font-size: 20px;
      font-weight: bold;
    }
    span:last-child {
      font-size: 14px;
      color: #525463;
    }
  }
}
</style>